import React, { useEffect, useState } from "react";
import folderbackicon from "../../Assets/folderbackicon.png";
import SearchBoxIcon from "../../Assets/SearchIcon.svg";
import styled from "styled-components";
import AddFolderIcon from "../../Assets/AddFolderIcon.png";
import "../../Styles/Folder/SingleFolderView.css";
import { useNavigate, useParams } from "react-router-dom";
import "../../Styles/Folder/ListViewofFolder.css";
import selecyedFormIcon from "../../Assets/selecyedFormIcon.png";
import axios from "axios";
import propertiesCloseIcon from "../../Assets/propertiesCloseIcon.svg";
import ListForm from "./ListForm";
import tagfileicon from "../../Assets/tagfileicon.svg";
import document_text from "../../Assets/document-text.png";
import ReactModal from "react-modal";
import closeIconselectedFolder from "../../Assets/closeIconselectedFolder.png";
import shareIcon from "../../Assets/shareIcon.svg";
import deleteIcon from "../../Assets/deleteIcon.svg";
import threedots from "../../Assets/threedots.svg";

const ProfileBasedLinks = styled.div`
  display: flex;
  gap: 20px;
`;

const AddFormModel = ({ isOpen, onClose, forms, getFolderDetails }) => {
  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      borderRadius: "15px",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "30%",
      height: "75%",
      display: "flex",
      flexDirection: "column",
      gap: "2rem",
      padding: "0px !important",
      backgroundColor: "#ffffff",
    },
    overlay: {
      background: "rgba(0,0,0,0.25)",
    },
  };

  const [selectedFormIds, setSelectedFormIds] = useState([]);
  const folderId = useParams();
  function formatUpdatedAt(date) {
    const options = { month: "short", day: "numeric", year: "numeric" };
    const formattedDate = new Date(date).toLocaleDateString("en-US", options);
    return `Updated on ${formattedDate}`;
  }

  const handelSelectedFomes = (formId) => {
    if (selectedFormIds.includes(formId)) {
      setSelectedFormIds(selectedFormIds.filter((id) => id !== formId));
    } else {
      setSelectedFormIds([...selectedFormIds, formId]);
    }
  };

  const handelCreateFormSubmit = async () => {
    const Url = process.env.REACT_APP_API;
    try {
      const response = await axios.post(
        `${Url}/folders/${folderId.folderId}/forms`,
        selectedFormIds
      );
      if (response.status === 200) {
        onClose();
        setSelectedFormIds([]);
        getFolderDetails();
      }
    } catch (error) {
      console.error(error);
    }
  };
  const handelCloseFolderModal = () => {
    onClose();
    setSelectedFormIds([]);
  };

  const [query, setQuery] = useState("");
  const filterForms = forms.filter((form) =>
    form.formTitle.toLowerCase().includes(query.toLowerCase())
  );
  if (!isOpen) return null;
  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={() => onClose()}
      style={customStyles}
      // contentLabel="Example Modal"
    >
      <div
        className="selectTagmodal-content"
        style={{
          position: "relative",
          height: "100%",
          justifyContent: "space-between",
        }}
      >
        <div>
          <div
            style={{
              position: "sticky",
              top: "0",
              background: "#ffffff",
              paddingBottom: "1rem",
              padding: "20px",
              display: "flex",
              flexDirection: "column",
              gap: "2rem",
            }}
          >
            <div className="propertiesTop">
              <p className="propertiesTitle folder-create">Add Forms</p>
              <img
                src={propertiesCloseIcon}
                alt="propertiesCloseIcon"
                style={{ cursor: "pointer" }}
                onClick={() => onClose()}
              />
            </div>
            <div className="selected-folder-container">
              <p>{selectedFormIds.length} Selected Forms</p>
              <div className="formlist-search-box-folderselect">
                <img src={SearchBoxIcon} alt="" />
                <input
                  type="text"
                  placeholder="search..."
                  className="search-box-style"
                  style={{ width: "100%" }}
                  value={query}
                  onChange={(e) => setQuery(e.target.value)}
                />
              </div>
            </div>
          </div>
          <div className="listof-forms-list" style={{ padding: "20px" }}>
            {filterForms?.map((form, i) => (
              <div
                className="single-file-details"
                key={i}
                onClick={() => handelSelectedFomes(form._id)}
                style={{
                  backgroundColor: selectedFormIds.includes(form._id)
                    ? "#8493B2"
                    : "#F6F8FC",
                }}
              >
                <div className="inside-contaienr-formdetails">
                  <div className="img-container">
                    <img
                      src={
                        selectedFormIds.includes(form._id)
                          ? selecyedFormIcon
                          : document_text
                      }
                      alt="document-text"
                    />
                  </div>
                  <div className="inside-formname-container-">
                    <p className="inside-formname-container-formname">
                      {form.formTitle}
                    </p>
                    <div className="tag-updated-date">
                      <div className="tagcount-container">
                        <div
                          style={{
                            width: "20px",
                            height: "20px",
                            color: "rgba(132, 147, 178, 1)",
                          }}
                        >
                          <img
                            src={tagfileicon}
                            alt="tagfileicon"
                            style={{
                              width: "100%",
                              height: "100%",
                            }}
                          />
                        </div>
                        <span>5</span>
                      </div>
                      <p
                        style={{
                          fontSize: "0.8rem",
                          color: "rgba(132, 147, 178, 1)",
                        }}
                      >
                        {formatUpdatedAt(form.updatedAt)}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="folder-action-container">
          <hr />
          <div className="buttons-from">
            <button
              className="folder-action-butoon1"
              onClick={handelCloseFolderModal}
            >
              Cancel
            </button>
            <button
              className="folder-action-butoon2"
              onClick={handelCreateFormSubmit}
            >
              Done
            </button>
          </div>
        </div>
      </div>
    </ReactModal>
  );
};

const SingleFolderView = () => {
  const navigate = useNavigate();
  const folderId = useParams();
  const [folderDetails, setFolderDetails] = useState([]);
  const [formsnotinFolder, setFormsnotinFolder] = useState([]);
  const URl = process.env.REACT_APP_API;
  const getFolderDetails = async () => {
    const response = await axios.get(
      `${URl}/folder/singlefolder/${folderId.folderId}`
    );
    if (response.status === 200) {
      setFolderDetails(response.data);
    }
  };
  useEffect(() => {
    getFolderDetails();
  }, [folderId.folderId, URl]);
  function formatUpdatedAt(date) {
    const options = { month: "short", day: "numeric", year: "numeric" };
    const formattedDate = new Date(date).toLocaleDateString("en-US", options);
    return `Updated on ${formattedDate}`;
  }

  const [isOpenAddForms, setAddForms] = useState(false);
  const handelAddFormFolder = async () => {
    try {
      const response = await axios.get(
        `${URl}//folders/${folderId.folderId}/forms/not-in`
      );
      if (response.status === 200) {
        setFormsnotinFolder(response.data.forms);
        setAddForms(true);
      }
    } catch (error) {
      console.log(error);
    }
    // setAddForms(true);
  };
  const colseAddForm = async () => {
    setAddForms(false);
  };

  const [query, setQuery] = useState("");
  const filterForms = folderDetails?.formDetails?.filter((forms) =>
    forms.formTitle.toLowerCase().includes(query.toLowerCase())
  );

  //selected forms

  const [selectedFormIds, setSelectedFormIds] = useState([]);

  const handelDeleteSelectedForms = async () => {
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_API}/folders/removeforms/${folderId.folderId}`,
        { formIds: selectedFormIds }
      );
      if (response.status === 200) {
        getFolderDetails();
        setSelectedFormIds([]);
      }
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <>
      <AddFormModel
        isOpen={isOpenAddForms}
        onClose={colseAddForm}
        forms={formsnotinFolder}
        getFolderDetails={getFolderDetails}
      />
      <div className="task-list-view" style={{ borderRadius: "2rem" }}>
        {selectedFormIds.length > 0 ? (
          <div className="folder-selected-container">
            <div className="close" onClick={() => setSelectedFormIds([])}>
              <img
                src={closeIconselectedFolder}
                alt="closeIconselectedFolder"
              />
            </div>
            <p>{selectedFormIds.length} Selected</p>
            <div>
              <img src={shareIcon} alt="" />
            </div>
            <div onClick={handelDeleteSelectedForms}>
              <img src={deleteIcon} alt="" />
            </div>
            <div>
              <img src={threedots} alt="" />
            </div>
          </div>
        ) : (
          <div className="topbar-single-folder">
            <div className="single-folder-back-button">
              <div onClick={() => navigate(-1)}>
                <img src={folderbackicon} alt="folderbackicon" />
              </div>
              <div className="foldder-name-updateAt-date">
                <h3>{folderDetails?.folderName}</h3>
                <div style={{ display: "flex" }}>
                  {formatUpdatedAt(folderDetails?.folderUpdated)}
                </div>
              </div>
            </div>
            <div className="filter-container-single-folder">
              <div className="formlist-search-box" style={{ height: "70%" }}>
                <img src={SearchBoxIcon} alt="" />
                <input
                  type="text"
                  placeholder="search..."
                  className="search-box-style"
                  value={query}
                  onChange={(e) => setQuery(e.target.value)}
                />
              </div>
              <ProfileBasedLinks>
                <img
                  src={AddFolderIcon}
                  alt=""
                  className="formlist-top-bar-logo"
                  onClick={() => {
                    handelAddFormFolder();
                  }}
                />
              </ProfileBasedLinks>
            </div>
          </div>
        )}
        <div>
          {
            <ListForm
              folderDetails={filterForms}
              folder={folderDetails}
              selectedFormIds={selectedFormIds}
              setSelectedFormIds={setSelectedFormIds}
            />
          }
        </div>
      </div>
    </>
  );
};

export default SingleFolderView;
